/* eslint-disable linebreak-style */
import React, { PureComponent } from 'react';
import { Tabs, Tab, Modal, Button, Table, InputGroup, FormControl, Card, ListGroup, Alert } from 'react-bootstrap';
import { FaExclamationTriangle, FaInfoCircle, FaSearch } from 'react-icons/fa';
import Helmet from 'react-helmet';
import ReactModal from 'react-modal';
import classnames from 'classnames';
import TopMenu from '../../../components/TopMenu';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import styles from './styles.module.scss';
import { BUNDLE } from '../../../utils/ui-bundle';
import LoadingSpinner from '../../../components/LoadingSpinner';

const lang = 'ZH';
const collection = 'FAOWA';
const searchIn = 'term';
const isBrowser = typeof window !== 'undefined';
// const protocol = isBrowser ? `${window.location.protocol}//` : '';
const baseUrl = `https://faoterm.fao.org/services/rest`;
const getEntries = 'getEntries.html';
const getEntry = 'getEntry.html';

class Glossary extends PureComponent {
    pageSize = 25;

    skip = 0;

    currentPage = 1;

    constructor(props) {
      super(props);
      this.state = {
        isModalOpen: false,
        data: [],
        modalValue: { termData: [], concept: { collection: {} } },
        searchTerm: '',
        numberOfPages: 0,
        take: this.pageSize,
        isDataLoaded: false,
        isDataLoading: false,
        hasErrorOccured: false,
      };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
      ReactModal.setAppElement('body');
    }

    componentDidMount() {
      this.searchBar.focus();
    }

    onSearchByTerm(event) {
      this.setState({ searchTerm: event.target.value });
    }

    searchTerm = (queryUrl) => {
      this.reset();
      this.setState({ isDataLoaded: false, isDataLoading: true, hasErrorOccured: false });
      fetch(queryUrl)
        .then(res => res.json())
        .then((data) => {
          const filtered = data
            .filter(dt => (dt.termData || [])
              .some(td => (td.sources || [])
                .some(src => ((src.source || '')
                  .toLowerCase().indexOf('aquastat')) !== -1)));

          this.setState({
            data: filtered,
            isDataLoaded: true,
            isDataLoading: false,
          });
        })
        .catch(() => {
          this.setState({
            hasErrorOccured: true,
            data: BUNDLE.COMMON.FETCHERROR[lang],
            isDataLoaded: false,
            isDataLoading: false,
          });
        });
    }

    getTermById = (conceptId) => {
      const queryUrl = `${baseUrl}/${getEntry}?id=${conceptId}`;
      fetch(queryUrl)
        .then(res => res.json())
        .then((data) => {
          this.setState({ isModalOpen: true, modalValue: data });
        })
        .catch(() => {
          this.setState({
            hasErrorOccured: true,
            data: BUNDLE.COMMON.FETCHERROR[lang],
            isDataLoaded: false,
            isDataLoading: false,
          });
        });
    }

    handleModalOpen = (data) => {
      const { conceptId } = data.termData[0];
      this.getTermById(conceptId);
    }

    handleModalClose = () => {
      this.setState({ isModalOpen: false });
    }

    scrollToRef = (ref) => {
      window.scrollTo(0, ref.current.offsetTop);
    }

    pageSelected(pageNumber) {
      this.currentPage = pageNumber;
      this.skip = 25 * (pageNumber - 1);
    }

    nextPage() {
      this.currentPage += 1;
      this.skip = 25 * (this.currentPage - 1);
    }

    previousPage() {
      this.currentPage -= 1;
      this.skip = 25 * (this.currentPage - 1);
    }

    reset() {
      this.skip = 0;
      this.currentPage = 1;
      this.setState({
        data: [],
        isDataLoaded: false,
      });
    }

    renderMetadata() {
      const { isDataLoading, data, numberOfPages } = this.state;

      return (
        !isDataLoading
            && (
            <div className={styles.metadata}>
              <div className={styles.pagingInfo}>
                {(typeof data !== 'string') ? data.length : 0 }
                <span>{data.length > 1 ? BUNDLE.FAOTERM.TERMS[lang] : BUNDLE.FAOTERM.TERM[lang]}</span>
              </div>
              <div className={styles.pagination}>
                <ul>
                  {(this.currentPage - 1 > 0)
                  && (
                  <li key="back" className={styles.back}>
                    <a href="#" onClick={this.previousPage.bind(this)}>&#60;&#60;</a>
                  </li>
                  )}

                  {(this.currentPage - 2 > 0)
                  && (
                  <li key="currentPageMinusOne">
                    <a href="#" onClick={this.pageSelected.bind(this, this.currentPage - 2)}>{this.currentPage - 2}
                    </a>
                  </li>
                  )}

                  {(this.currentPage - 1 > 0)
                  && (
                  <li key="currentPageMinusTwo">
                    <a href="#" onClick={this.pageSelected.bind(this, this.currentPage - 1)}>{this.currentPage - 1}
                    </a>
                  </li>
                  )}

                  <li key="currentPage" className={styles.currentPage}>{this.currentPage}</li>

                  {(this.currentPage + 1 < numberOfPages)
                  && (
                  <li key="currentPagePlusOne">
                    <a href="#" onClick={this.pageSelected.bind(this, this.currentPage + 1)}>{this.currentPage + 1}
                    </a>
                  </li>
                  )}

                  {(this.currentPage + 2 < numberOfPages)
                  && (
                  <li key="currentPagePlusTwo">
                    <a href="#" onClick={this.pageSelected.bind(this, this.currentPage + 2)}>{this.currentPage + 2}
                    </a>
                  </li>
                  )}

                  {(this.currentPage + 1 < numberOfPages)
                  && (
                  <li key="next" className={styles.next}>
                    <a href="#" onClick={this.nextPage.bind(this)}>&#62;&#62;<i className="fa fa-angle-double-right" />
                    </a>
                  </li>
                  )}
                </ul>
              </div>
            </div>
            )
      );
    }

    renderSearchArea() {
      const { searchTerm } = this.state;
      return (
        <InputGroup className={classnames('mb-3')}>
          <FormControl
            ref={(input) => { this.searchBar = input; }}
            placeholder={BUNDLE.FAOTERM.SEARCHBYTERM[lang]}
            aria-label={BUNDLE.FAOTERM.SEARCHBYTERM[lang]}
            aria-describedby={BUNDLE.FAOTERM.SEARCHBYTERM[lang]}
            value={searchTerm}
            onChange={this.onSearchByTerm.bind(this)}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                this.searchTerm(
                  `${baseUrl}/${getEntries}?searchValue=${encodeURI(searchTerm.trim())}&searchIn=${searchIn}&lang=${lang}&collection=${collection}`,
                );
              }
            }}
          />
          <InputGroup.Append>
            <Button
              variant="outline-primary"
              onClick={() => {
                this.searchTerm(
                  `${baseUrl}/${getEntries}?searchValue=${encodeURI(searchTerm.trim())}&searchIn=${searchIn}&lang=${lang}&collection=${collection}`,
                );
              }}
            >
              <FaSearch />
            </Button>
          </InputGroup.Append>
        </InputGroup>
      );
    }

    renderBody() {
      const { isDataLoaded, isDataLoading, hasErrorOccured, data } = this.state;
      return (
        (!isDataLoaded && !isDataLoading && !hasErrorOccured
          ? ('')
          : (
            <div className={styles.resultArea}>
              {this.renderMetadata()}
              {
                <Table
                  striped
                  bordered
                  hover
                  size="sm"
                >
                  <thead>
                    <tr>
                      <th>{BUNDLE.FAOTERM.TERM[lang]}</th>
                      <th>{BUNDLE.FAOTERM.SBJCT[lang]}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {typeof data === 'string' || data.length === 0
                      ? (
                        <tr className={styles.dataStatus}>
                          {
                             isDataLoaded
                               ? (
                                 Glossary.renderErrorMessage(data)
                               )
                               : (
                                 Glossary.renderDataFetchingStatus(isDataLoading, data)
                               )
                          }
                        </tr>
                      ) : (this.renderTableData())}
                  </tbody>
                </Table>
              }
            </div>
          ))
      );
    }

    static renderErrorMessage(data) {
      let msg;

      if (typeof data === 'string') msg = data;
      else if (data.length === 0) msg = BUNDLE.COMMON.NODATA[lang];
      else msg = BUNDLE.FAOTERM.UNKERR[lang];

      return (
        <td colSpan="2" className={styles.errorMessage}>
          <FaExclamationTriangle className={styles.icon} />
          <span className={styles.message}>
            {msg}
          </span>
        </td>
      );
    }

    static renderDataFetchingStatus(isDataLoading, data) {
      if (isDataLoading) {
        return (
          <td colSpan="2">
            <LoadingSpinner />
          </td>
        );
      }
      return (
        <td colSpan="2" className={styles.errorMessage}>
          <FaExclamationTriangle className={styles.icon} />
          <span className={styles.message}>{typeof data === 'string' ? data : BUNDLE.FAOTERM.UNKERR[lang]}</span>
        </td>
      );
    }

    renderTableData() {
      const { data, take } = this.state;
      const availableRecordSize = data.length;
      this.setState({ numberOfPages: Math.ceil(availableRecordSize / this.pageSize) });

      if (this.skip >= availableRecordSize) {
        this.skip = availableRecordSize - take;
      }

      if (data.length === 0 || typeof data === 'string') {
        return (
          <tr>
            <td className={styles.errorMessage} colSpan="2">
              <FaExclamationTriangle className={styles.icon} />
              <span className={styles.message}>{data}</span>
            </td>
          </tr>
        );
      }

      return data
        .slice(this.skip, take + this.skip)
        .map((dt) => {
          const { termData, concept } = dt;
          return (
            <tr
              onClick={() => { this.handleModalOpen({ termData, concept }); }}
              className={styles.clickabelRow}
              key={termData[0].id}
            >
              <td>
                {termData[0].term}
              </td>
              <td>{concept.conceptSubjectList[0].label}</td>
            </tr>
          );
        });
    }

    renderModal() {
      const { isModalOpen, modalValue } = this.state;
      const lngs = Object.entries(modalValue.termData) || [];

      return (
        <Modal show={isModalOpen} onHide={this.handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>{BUNDLE.FAOTERM.DTLTITLE[lang]}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={styles.modalContent}>
              <div className={styles.details}>
                <Tabs defaultActiveKey={lang} id="lang-tab">
                  {lngs.map((trm) => (
                    <Tab
                      eventKey={trm[0]}
                      title={trm[0]}
                      className={trm[0] !== 'AR' ? styles.ltr : styles.rtl}
                      key={trm[0]}
                    >
                      <Card>
                        <ListGroup variant="flush">
                          {(trm[1] || []).map((crntTrm) => {
                            const { term, remarks } = (crntTrm || {});
                            const { definition, source } = ((crntTrm || {}).definitions[0] || {});
                            const { relatedTerms } = (crntTrm || {});
                            const termSources = ((crntTrm || {}).sources || []);
                            const termSource = termSources.length > 1
                              ? termSources.find(ts => ts.source.toUpperCase().indexOf('AQUASTAT'))
                              : termSources[0];

                            return (
                              <ListGroup.Item key={crntTrm.id}>
                                <h3>{term}</h3>
                                {termSource && (
                                  <div>
                                    <b>{BUNDLE.FAOTERM.TRMSRC[lang]}:</b><p>{termSource.source || 'N/A'}</p>
                                  </div>
                                )}
                                {definition && (
                                  <div>
                                    <b>{BUNDLE.FAOTERM.DFNTN[lang]}:</b>
                                    <p> {definition || 'N/A'}</p>
                                  </div>
                                )}
                                {source && (
                                  <div>
                                    <b>{BUNDLE.FAOTERM.DFNSRC[lang]}:</b>
                                    <p>{source || 'N/A'}</p>
                                  </div>
                                )}
                                {relatedTerms && (
                                  <div>
                                    <b>{BUNDLE.FAOTERM.RLTDTRM[lang]}:</b>
                                    <p> {relatedTerms || 'N/A'}</p>
                                  </div>
                                )}
                                {(remarks && remarks.length > 0) && (
                                  <div>
                                    <b>{BUNDLE.FAOTERM.RMRK[lang]}:</b>
                                    <span>
                                      <ol>
                                        {remarks.map(rmrk => <li key={rmrk.id}>{rmrk.remarks}</li>)}
                                      </ol>
                                    </span>
                                  </div>
                                )}
                              </ListGroup.Item>
                            );
                          })}
                        </ListGroup>
                      </Card>

                    </Tab>
                  ))}
                </Tabs>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleModalClose}>
              {BUNDLE.FAOTERM.CLS[lang]}
            </Button>
          </Modal.Footer>
        </Modal>
      );
    }

    render() {
      return (
        <div>
          <Helmet
            title={BUNDLE.COMMON.SITETITLE[lang]}
            meta={[
              { name: 'description', content: 'FAO AQUASTAT' },
              { name: 'keywords', content: 'fao, water, aquastat, water production, Glossary' },
            ]}
          />
          <Header siteTitle="AQUASTAT" location={{}} />
          <div className="app-wrapper">
            <h2 className="site-title">{BUNDLE.COMMON.SITETITLE[lang]}</h2>
            <TopMenu location="/databases/glossary" />
            <div className={styles.pageWrapper}>
              <div className={styles.infoAreaWrapper}>
                <h2>{BUNDLE.FAOTERM.GLSRY[lang]}</h2>

                <Alert key="info" className={styles.introText}>
                  {BUNDLE.FAOTERM.SHRTDSC[lang]}
                </Alert>
              </div>

              <div className={styles.searchAreaWrapper}>
                {this.renderSearchArea()}
              </div>

              <div className={classnames(styles.howToWrapper)}>
                <Alert key="guide" className={styles.startMessage}>
                  <FaInfoCircle className={styles.icon} />
                  <span className={classnames(styles.message, styles.smallerText)}>
                    {BUNDLE.FAOTERM.GUIDE[lang]}
                  </span>
                </Alert>
              </div>


              {this.renderBody()}
              {this.renderModal()}
            </div>
          </div>
          <Footer />
        </div>
      );
    }
}

export default Glossary;
